import {
  ShopDetailScreen,
  ShopDetailScreenProps,
} from '@bounty/creators-common/screens/shop/ShopDetail/ShopDetail'
import { GetStaticPaths } from 'next'
import { GetStaticPropsWithSEO } from '@bounty/creators-common/types'
import { withSEO } from '../../withSEO'
import { CreatorsClient } from '@bounty/creators-common/libs/creators'
import { ReactElement } from 'react'
import { Layout } from '../../Layout'
import { NextPageWithLayout } from '../_app'

export const getStaticPaths: GetStaticPaths = async () => {
  /**
   * NOTE: Next appears to have problems prerendering 20 pages due to the upload limits in their API. Prerendering also makes sitemaps have
   * duplicate entries so we're going to build all pages on the fly for now.
   *
   * This is paginated so we're only prerendering the initial routes
   */
  // const resp = await new CreatorsClient().getStores()

  return {
    paths: [],
    fallback: 'blocking', // can also be true or 'blocking'
  }
}

export const getStaticProps: GetStaticPropsWithSEO<
  ShopDetailScreenProps,
  { slug: string }
> = async (context) => {
  const { slug } = context.params!

  const response = await new CreatorsClient().getStore(slug, {
    views: '1000',
    includeDisabledStores: 'false',
  })

  if (!response.success || !response.data) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      fallback: {
        [CreatorsClient.produceCacheKey('getStore', slug, {
          views: '1000',
          includeDisabledStores: 'false',
        })]: response.data,
      },
      seo: {
        title: response.data.name,
        description: `Shop ${response.data.name} on Bounty and get paid! ${response.data.description}`,
        openGraph: {
          type: 'website',
          locale: 'en_US',
          url: 'https://www.bounty.co/',
          siteName: 'Bounty',
          description: `Get paid cash back for sharing the products you love on TikTok. It's the easiest way to get paid as a creator.`,
          images: [
            {
              url: response.data.headerImgLinkPrimary,
              alt: `Shop ${response.data.name} on Bounty and get paid!`,
              height: 630,
              width: 1200,
              type: 'image/jpeg',
            },
          ],
        },
      },
    },
  }
}

const Page: NextPageWithLayout = withSEO(ShopDetailScreen)

Page.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>
}

export default Page
